import * as yup from "yup";
export const AccountSettingsValidationSchema = yup.object({});
